import { Component, OnInit } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';
import { PlanDataService } from "../../Plans/PlanDef/PlanService";
import { ProgramTemplateData, TemplatePlan } from "app/@core/interfaces/common/CalorieFriend/plan";
import { ProgramPlans } from "app/@core/interfaces/common/CalorieFriend/program-template";
import { finalize } from "rxjs/operators";


@Component({
  selector: 'app-program-template-edit',
  templateUrl: 'program-template-edit.html',
  styleUrls: ['./program-template-edit.scss'],
})
export class ProgramTemplateEditComponent implements OnInit {
  public selectedIndex: number = 0;
  public template :TemplatePlan<ProgramPlans>;
  constructor(private router: Router, private activeRoute: ActivatedRoute, private location: Location,
    private programTemplateService: ProgramTemplateData) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      this.programTemplateService.GetTemplateById(params.id).subscribe((data) => {
        this.template = data;
      });
    });
    this.activeRoute.queryParams.subscribe((params) => {
      if(params.activeTab){
        this.selectedIndex = params.activeTab;
      }
    });
  }

  public onChangeTab(event: MatTabChangeEvent) {
    console.log(event);
    this.selectedIndex = event.index;
    const tabIndex = event.index;
    const currentUrl = this.location.path();
    const newUrl = this.updateUrlParameter(currentUrl, 'activeTab', tabIndex.toString());
    this.location.replaceState(newUrl);
  }

  Back(){
    this.router.navigate(['/pages/CalorieFriend/program-template']);
  } 
  public updatingTemplate: boolean = false;

  onNameChange($event) {
    if(this.template && (typeof $event) === "string" &&  this.template?.name!== $event) {
      this.template.name = $event;
      this.updatingTemplate = true;
      this.programTemplateService.UpdateTemplate(this.template, true)
      .pipe(finalize(() => this.updatingTemplate = false))
      .subscribe((data) => {
        });
    }
  }

  updateUrlParameter(url: string, param: string, paramVal: string): string {
    let newAdditionalURL = "";
    let tempArray = url.split("?");
    let baseURL = tempArray[0];
    let additionalURL = tempArray[1];
    let temp = "";
    if (additionalURL) {
      tempArray = additionalURL.split("&");
      for (let i=0; i<tempArray.length; i++){
        if(tempArray[i].split('=')[0] !== param){
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    }
  
    let rowsTxt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rowsTxt;
  }
}